import React, { useEffect, useState } from 'react';
import ClassicNotifications from '@ux/notifications';
import Notifications from './Notifications';
import request from '../request';
import { getBaseApiUrl } from '../utils';

const getExperiment = async () => {
  try {
    const response = await request({
      url: `${getBaseApiUrl()}/v1/experiment`,
      method: 'GET',
      mode: 'cors'
    });
    return response;
  } catch (error) {
    return { cohortId: 'off' };
  }
};

const NotificationsLoader = (props) => {
  const [cohortId, setCorhortId] = useState(null);

  useEffect(() => {
    getExperiment().then(experiment => setCorhortId(experiment?.cohortId));
  }, []);

  const Component = cohortId === 'on' ? Notifications : ClassicNotifications;

  return (
    <div id='site-notifications-wrapper' style={{ display: 'flex' }}>
      { !cohortId || cohortId === 'ineligible' ? null : <Component { ...props } /> }
    </div>
  );
};

export default NotificationsLoader;
